import {
    DataGrid, useGridApiContext, deDE, useGridApiRef, GridToolbarContainer, GridRowModes,
    GridActionsCellItem,
    renderBooleanCell,
    renderEditBooleanCell,
} from '@mui/x-data-grid';
import { NumericFormat } from 'react-number-format';
import { styled, darken, lighten } from '@mui/material/styles';
import uuid from "uuid";
import Snackbar from '@mui/material/Snackbar';

import { Button, Select, Card, Descriptions, Input, Space, message, InputNumber, Divider, Popconfirm } from 'antd';
import React from 'react'
import { useEffect, useState, useMemo, useRef } from 'react'
import { currencyFormatter, currencyParser, formatCurrency } from '../../util/Helpers';
import { DeleteOutlined, PlusCircleOutlined, SaveOutlined, PlusOutlined } from '@ant-design/icons';
import { deleteAccountingItem, getProjectDetailAccountingItems, updateAccountingItem } from '../../util/APIUtils';
import { Box } from '@mui/system';
import { TableCell, TableRow } from '@mui/material';
import CreatableSelect from 'react-select/creatable';
import SelectEditInputCell from '../../common/SelectEditInputCell';
import { CheckBoxOutlineBlankTwoTone, CheckBoxOutlined } from '@mui/icons-material';


const getBackgroundColor = (color, mode) =>
    mode === 'dark' ? darken(color, 0.7) : lighten(color, 0.7);
const getHoverBackgroundColor = (color, mode) =>
    mode === 'dark' ? darken(color, 0.6) : lighten(color, 0.6);

const useFakeMutation = () => {
    return;
};


const EditableGridAccounting = (props) => {
    const [loading, setLoading] = useState(false);
    const [editing, setEditing] = useState(false);
    const projectId = props.projectId;
    const projectDetailId = props.projectDetailId;
    const [state, setState] = useState({})
    const editable = props.reportEditable;
    const accountingItems = props.accountingItems;
    const isPlanEditable = props.isPlanEditable;
    const isReportEditable = props.isReportEditable;
    const [data, setData] = useState(props.data || []);
    const [rowModesModel, setRowModesModel] = React.useState({});
    const [snackbar, setSnackbar] = React.useState(null);
    const handleCloseSnackbar = () => setSnackbar(null);
    const [budgetTotal, setBudgetTotal] = useState(0);
    const [actualTotal, setActualTotal] = useState(0);

    const loadAccountingItems = React.useCallback(async () => {
        let promise;
        promise = getProjectDetailAccountingItems(projectDetailId);

        if (!promise) {
            return;
        }
        setLoading(true);
        promise.then(response => {
            response.push(createSummaryData(response));
            setData(response);
        }).catch(error => {
            console.log(error)
            setLoading(false)
        });
    }, [])

    useEffect(() => {
        loadAccountingItems();
    }, [loadAccountingItems]);

    const is2027OrLater = props.year >= 2027;

    const createSummaryData = (response) => {
        let summaryRow = createNewRow("sum")
        summaryRow.accountingItem = "Gesamt"
        // summaryRow.actualTotalAmount = response.reduce((a, b) => a + (b['actualTotalAmount'] || 0), 0).toFixed(2)
        summaryRow.budgetTotalAmount = response.reduce((a, b) => a + (b['budgetTotalAmount'] || 0), 0).toFixed(2)
        summaryRow.daysResearcherBudget = response.reduce((a, b) => a + (b['daysResearcherBudget'] || 0), 0).toFixed(2)
        summaryRow.daysResearcherActual = response.reduce((a, b) => a + (b['daysResearcherActual'] || 0), 0).toFixed(2)
        summaryRow.daysHelperBudget = is2027OrLater ? 0 : response.reduce((a, b) => a + (b['daysHelperBudget'] || 0), 0).toFixed(2)
        summaryRow.daysHelperActual = is2027OrLater ? 0 : response.reduce((a, b) => a + (b['daysHelperActual'] || 0), 0).toFixed(2)
        summaryRow.actualTotalAmount = response.filter(a => a.actualSelected == true).reduce((a, b) => a + (b['actualTotalAmount'] || 0), 0).toFixed(2)
        return summaryRow;
    }

    const mutateRow = useFakeMutation();

    const CustomToolbar = () => {
        const apiRef = useGridApiContext();
        const handleSave = () => console.log(apiRef.current.getRowModels());

        if (isReportEditable || isPlanEditable) {
            return (
                <GridToolbarContainer >
                    <Space>
                        <Button onClick={handleAddRow} style={{ marginBottom: "10px" }} icon={<PlusOutlined />}>
                        </Button>
                    </Space>
                </GridToolbarContainer>
            );
        }
        else {
            return null
        }
    };

    const getAccountingItemIdForDesc = (desc) => {
        let item = accountingItems.find(x => x.description === desc) || null;
        if (item) {
            return item.id;
        } else {
            return;
        };
    }

    function CurrencyInputCell(props) {
        const { id, value, field } = props;
        const apiRef = useGridApiContext();

        const handleChange = async (event) => {
            await apiRef.current.setEditCellValue({ id, field, value: event.target.value });
        };

        return (
            <NumericFormat
                style={{ height: "100px", minWidth: "48px", border: "0px", borderColor: "green" }}
                autoFocus
                align='right'
                value={value} decimalSeparator="," onChange={handleChange} />
        )
    }

    const handleParentClick = (e) => {
        e.stopPropagation();
    }

    const renderSelectEditInputCell = (params) => {
        return (<div style={{ minWidth: "400px", borderWidth: "0px" }} onClick={handleParentClick}>
            {/* eslint-disable-next-line react-hooks/rules-of-hooks */}
            <SelectEditInputCell {...params} items={accountingItems} itemName='description' apiRef={useGridApiContext()} />
        </div>);
    };

    const renderCurrencyInputCell = (params) => {
        return <CurrencyInputCell {...params} />;
    };

    const renderCustomToolbar = (params) => {
        return <CustomToolbar {...params} />;
    };

    const createNewRow = (type) => {
        return {
            id: type == "sum" ? 108080 : 0,
            accountingItem: "",
            actualTotalAmount: 0,
            budgetTotalAmount: 0,
            daysHelperActual: 0,
            daysHelperBudget: 0,
            daysResearcherActual: 0,
            daysResearcherBudget: 0,
            isNew: true,
            projectId: projectId,
            projectDetailId: projectDetailId,
            budget: isPlanEditable,
            actual: isReportEditable,
            rowType: type
        }
    }

    const deleteSum = (arr) => {
        let localArr = [...arr];
        localArr.splice(localArr.findIndex(function (i) {
            return i.id === 108080;
        }), 1);
        return localArr;
    }

    const handleAddRow = () => {
        setData((prevRows) => [...deleteSum(prevRows)]);
        setData((prevRows) => [...prevRows, createNewRow(null), createSummaryData(prevRows)]);
    };

    const renderDeleteButton = (params) => {

        const onCancel = () => {
            return
        }

        const onOk = () => {
            setLoading(true)

            let promise = deleteAccountingItem(params.row.id);
            if (!promise) {
                return;
            }

            promise.then(response => {
                setLoading(false);
                loadAccountingItems();


            }).catch(error => {
                message.error("Failed")
            });

        }


        if (params.row.id === 0 && params.row.accountingItem == "") {
            return ""
        }

        if (params.row.rowType === "sum") {
            return ""
        } else {
            return (
                <strong>

                    {(params.row.budget && isPlanEditable) || (params.row.actual && isReportEditable) ?
                        <Popconfirm
                            title="Löschen bestätigen?"
                            onConfirm={onOk}
                            onCancel={onCancel}
                            okText="Ok"
                            cancelText="Abbrechen"
                        >
                            <Button danger icon={<DeleteOutlined />}
                                size="small"
                                style={{ marginLeft: 16 }}
                            // onClick={onOk}
                            >
                            </Button>
                        </Popconfirm> : ""}

                </strong>
            )
        }

    }


    const columnGroupingModel = is2027OrLater ? [
        {
            groupId: 'Tätigkeitsaufwand (in Tage)',
            description: '',
            headerAlign: 'center',
            children: [{ field: 'daysResearcherBudget' }, { field: 'daysResearcherActual' }],
        },
        {
            groupId: 'Vergütung (in €)',
            description: '',
            headerAlign: 'center',
            children: [{ field: 'budgetTotalAmount' }, { field: 'actualTotalAmount' }],
        },
    ] : [
        {
            groupId: 'Züchter',
            description: '',
            headerAlign: 'center',
            children: [{ field: 'daysResearcherBudget' }, { field: 'daysResearcherActual' }],
        },
        {
            groupId: 'Hilfskraft',
            description: '',
            headerAlign: 'center',
            children: [{ field: 'daysHelperBudget' }, { field: 'daysHelperActual' }],
        },
        {
            groupId: 'Gesamt',
            description: '',
            headerAlign: 'center',
            children: [{ field: 'budgetTotalAmount' }, { field: 'actualTotalAmount' }],
        },
    ];

    const renderActualSelected = (row) => {
        if(row.row.accountingItem === 'Gesamt') {
            return "";
        } else {
            return row.row.actualSelected ? <CheckBoxOutlined /> : <CheckBoxOutlineBlankTwoTone />
        }
    }


    const columns = [
        
        { field: 'accountingItemId', headerName: 'Id', hide: true, minWidth: 600, editable: true },
        { field: 'actualSelected', headerName: 'Abrechnung', minWidth: 20, editable: true, type: 'boolean', flex: 1, hide: isPlanEditable, renderCell: renderActualSelected },
        { field: 'accountingItem', headerName: 'Tätigkeiten', minWidth: 400, editable: true, renderEditCell: renderSelectEditInputCell, flex: 1 },
        {
            field: 'daysResearcherBudget',
            headerName: 'Kalkulation',
            valueFormatter: ({ value }) => currencyFormatter(value),
            // valueGetter: ({ value }) => currencyParser(value),
            renderEditCell: renderCurrencyInputCell,
            editable: isPlanEditable,
            headerAlign: 'right',
            align: 'right',
            minWidth: 50,
            flex: 1
        },
        {
            field: 'daysResearcherActual',
            headerName: 'Abrechnung',
            valueFormatter: ({ value }) => currencyFormatter(value),
            renderEditCell: renderCurrencyInputCell,
            // type: 'number',
            minWidth: 50,
            flex: 1,
            editable: isReportEditable,
            headerAlign: 'right',
            align: 'right'
        },
        ...(!is2027OrLater ? [
            {
                field: 'daysHelperBudget',
                headerName: 'Kalkulation',
                valueFormatter: ({ value }) => currencyFormatter(value),
                renderEditCell: renderCurrencyInputCell,
                minWidth: 50,
                flex: 1,
                editable: isPlanEditable,
                headerAlign: 'right',
                align: 'right'
            },
            {
                field: 'daysHelperActual',
                headerName: 'Abrechnung',
                headerClassName: 'table-header',
                valueFormatter: ({ value }) => currencyFormatter(value),
                renderEditCell: renderCurrencyInputCell,
                minWidth: 50,
                flex: 1,
                editable: isReportEditable,
                headerAlign: 'right',
                align: 'right',
            }
        ] : []),
        {
            field: 'budgetTotalAmount',
            headerName: 'Kalkulation',
            valueFormatter: ({ value }) => formatCurrency(value),
            // renderEditCell: renderCurrencyInputCell,
            type: 'number',
            minWidth: 100,
            flex: 1,
            // editable: true,
            headerAlign: 'right',
            align: 'right',
            // valueGetter: getTotalBudget,
            // valueSetter: setTotalBudget,
            // valueParser: parseTotalBudget
        },
        {
            field: 'actualTotalAmount',
            headerName: 'Abrechnung',
            valueFormatter: ({ value }) => formatCurrency(value),
            // renderEditCell: renderCurrencyInputCell,
            type: 'number',
            minWidth: 100,
            flex: 1,
            // editable: true,
            headerAlign: 'right',
            align: 'right',
        },

        {
            field: 'action',
            headerName: 'Action',
            // renderEditCell: renderCurrencyInputCell,
            minWidth: 20,
            flex: 1,
            // editable: true,
            headerAlign: 'center',
            align: 'center',
            renderCell: renderDeleteButton,
            disableClickEventBubbling: true,

        },
    ];

    const processRowUpdate = React.useCallback(
        async (newRow) => {
            newRow.customItem = newRow.accountingItem ? newRow.accountingItem : null;
            newRow.customType = newRow.customItem ? true : false;
            if (newRow.customType) {
                newRow.accountingItemId = 0;
            } else {
                newRow.accountingItemId = getAccountingItemIdForDesc(newRow.accountingItem)
            }

            newRow.daysResearcher = currencyParser(currencyFormatter(newRow.daysResearcherBudget));
            newRow.daysHelper = is2027OrLater ? 0 : currencyParser(currencyFormatter(newRow.daysHelperBudget));
            newRow.daysResearcherActual = currencyParser(currencyFormatter(newRow.daysResearcherActual));
            newRow.daysHelperActual = is2027OrLater ? 0 : currencyParser(currencyFormatter(newRow.daysHelperActual));

            let promise = updateAccountingItem(newRow);
            if (!promise) {
                return;
            }

            promise.then(response => {
                const updatedRow = { ...newRow, isNew: false };
                // setData(data.map((row) => (row.id === newRow.id ? updatedRow : row)));
                response.push(createSummaryData(response))
                setData(response);
                setBudgetTotal(response.reduce((a, b) => a + (b['budgetTotalAmount'] || 0), 0));
                setActualTotal(response.reduce((a, b) => a + (b['actualTotalAmount'] || 0), 0))
            }).catch(error => {
                message.error("project update failed")
            });
            return newRow;
        },
        [mutateRow],
    );

    const handleProcessRowUpdateError = React.useCallback((error) => {
        setSnackbar({ children: error.message, severity: 'error' });
    }, []);

    const checkEditable = (param) => {

        if (param.row.rowType === "sum") {
            return false;
        }
        if (param.colDef.field === "accountingItem" && param.row.budget && isPlanEditable) {
            return true;
        }

        if (param.colDef.field === "accountingItem" && param.row.actual && isReportEditable) {
            return true;
        }

        if (isPlanEditable && ['daysResearcherBudget', 'daysHelperBudget'].includes(param.colDef.field)) {
            return true;
        }

        if (isReportEditable && ['actualSelected', 'daysResearcherActual', 'daysHelperActual'].includes(param.colDef.field)) {
            return true;
        }

        return false;

    }

    function CustomFooter(props) {
        return (
            <Box sx={{ fontWeight: "600", border: `1px solid #f0f0f0`, backgroundColor: "#f1f7ee", padding: "0px", display: "flex", justifyContent: "right", alignItems: "right" }}>
            </Box>)
    }

    const StyledDataGrid = styled(DataGrid)(({ theme }) => ({
        border: 1,
        color:
            theme.palette.mode === 'light' ? 'rgba(0,0,0,.85)' : 'rgba(255,255,255,0.85)',
        fontFamily: [
            '-apple-system',
            'BlinkMacSystemFont',
            '"Segoe UI"',
            'Roboto',
            '"Helvetica Neue"',
            'Arial',
            'sans-serif',
            '"Apple Color Emoji"',
            '"Segoe UI Emoji"',
            '"Segoe UI Symbol"',
        ].join(','),
        WebkitFontSmoothing: 'auto',
        letterSpacing: 'normal',
        '& .MuiDataGrid-columnsContainer': {
            backgroundColor: theme.palette.mode === 'light' ? '#fafafa' : '#1d1d1d',
        },
        '& .MuiDataGrid-iconSeparator': {
            display: 'none',
        },
        '& .MuiDataGrid-columnHeader, .MuiDataGrid-cell': {
            // backgroundColor: '#ccc',
            border: `1px solid ${theme.palette.mode === 'light' ? '#f0f0f0' : '#303030'
                }`,
        },
        '& .MuiDataGrid-columnsContainer, .MuiDataGrid-cell': {
            border: `1px solid ${theme.palette.mode === 'light' ? '#f0f0f0' : '#303030'
                }`,
        },
        '& .MuiDataGrid-columnHeader, .MuiDataGrid-columnHeaders, MuiDataGrid-columnHeaderRow': {
            // height: '26px !important',
            // lineHeight: '26px !important',
            backgroundColor: '#f1f7ee',
        },
        '& .MuiDataGrid-columnHeadersInner': {
            // height: '60px !important',
          },
          '& .MuiDataGrid-columnHeaderTitleContainer': {
            padding: 0,
          },
        '& .MuiDataGrid-cell': {

            color:
                theme.palette.mode === 'light' ? 'rgba(0,0,0,.85)' : 'rgba(255,255,255,0.65)',
        },
        '& .MuiPaginationItem-root': {
            borderRadius: 0,
        },
        
        '& .sum-row-sum': {
            bgcolor: (theme) =>
                getBackgroundColor(theme.palette.success.main, theme.palette.mode),
            '&:hover': {
                bgcolor: (theme) =>
                    getHoverBackgroundColor(
                        theme.palette.success.main,
                        theme.palette.mode,
                    ),
            },
        },

    }));

    return (
        <div style={{ width: "100%", marginBottom: "10px" }}>
            <br></br>
            <Box
                sx={{
                    width: '100%',
                    '& .budget': {
                        backgroundColor: '#dde5b6',
                        color: 'e8e8e4',
                    },
                    '& .actual': {
                        backgroundColor: '#fae1ca',
                        color: '#1a3e72',
                    },
                    '& .actual-selected': {
                        backgroundColor: 'white',
                        color: 'green !important',
                    },
                    '& .actual-not-selected': {
                        // backgroundColor: '#fae1ca',
                        color: 'red !important',
                    },
                    '& .sum-row': {
                        backgroundColor: '#f1f7ee',
                        fontWeight: 800,
                        color: 'black !important',
                    },
                }}
            >
                <StyledDataGrid
                    disableColumnFilter
                    disableClickEventBubbling
                    disableSelectionOnClick
                    autoHeight
                    rowHeight={27}
                    headerHeight={60}
                    // headerRowHeight={27}
                    rows={data}
                    columns={columns}
                    experimentalFeatures={{ newEditingApi: true, columnGrouping: true }}
                    localeText={deDE.components.MuiDataGrid.defaultProps.localeText}
                    columnGroupingModel={columnGroupingModel}
                    processRowUpdate={processRowUpdate}
                    disableColumnMenu
                    isCellEditable={checkEditable}
                    onProcessRowUpdateError={handleProcessRowUpdateError}
                    getRowClassName={(params) => {
                        if (params.row.rowType === "sum") {
                            return 'sum-row'
                        }
                    }}
                    getCellClassName={(params) => {
                        if (['daysResearcherBudget', 'daysHelperBudget'].includes(params.field)) {
                            return 'budget';
                        } else if (['daysResearcherActual', 'daysHelperActual'].includes(params.field)) {
                            return 'actual'
                        }
                        if(params.field == "actualTotalAmount") {
                            if(params.row.actualSelected) {
                                return 'actual-selected'
                            } else {
                                if (params.row.rowType === "sum") {
                                    return
                                }
                                return 'actual-not-selected'
                            }
                        }

                    }}
                    components={{
                        Toolbar: renderCustomToolbar,
                        Footer: CustomFooter
                    }}
                    componentsProps={{
                        footer: { budgetTotal, actualTotal }
                    }}
                />
            </Box>
        </div>

    )
}

export default EditableGridAccounting